import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Projects } from './pages/Projects/Projects'
import { RoutesEnum } from './model/enums/RoutesEnum'
import { Playground } from './pages/Playground/Playground'
import React from 'react'
import { Login } from './pages/Login/Login'
import { Contacts } from './pages/Contacts/Contacts'
import { ProjectPreview } from './pages/Preview/ProjectPreview'
import { UserProfile } from './pages/UserProfile/UserProfile'
import { UserResetPassword } from './pages/UserResetPassword/UserResetPassword'
import { UserForgottenPassword } from './pages/UserForgottenPassword/UserForgottenPassword'
import { WorkspaceSettings } from './pages/WorkspaceSettings/WorkspaceSettings'
import { WorkspaceUsers } from './pages/WorkspaceSettings/subpages/WorkspaceUsers'
import { WorkspaceBilling } from './pages/WorkspaceSettings/subpages/WorkspaceBilling'
import { AI } from './pages/AI/AI'
import { Tasks as TasksPage } from './pages/Tasks/Tasks'
import { projectSubpageRoutes } from './model/constants/routes/projectSubpageRoutes'

export const router = createBrowserRouter([
  {
    path: RoutesEnum.LOGIN,
    element: <Login />,
  },
  {
    path: RoutesEnum.PROJECTS,
    element: <Projects />,
  },
  ...projectSubpageRoutes,
  {
    path: RoutesEnum.CONTACTS,
    element: <Contacts />,
  },
  {
    path: RoutesEnum.USER_PROFILE,
    element: <UserProfile />,
  },
  {
    path: `${RoutesEnum.USER_RESET_PASSWORD}/:hash`,
    element: <UserResetPassword />,
  },
  {
    path: `${RoutesEnum.USER_FORGOTTEN_PASSWORD}`,
    element: <UserForgottenPassword />,
  },
  {
    path: `${RoutesEnum.WORKSPACE_SETTINGS}`,
    element: <WorkspaceSettings />,
  },
  {
    path: `${RoutesEnum.WORKSPACE_SETTINGS_USERS}`,
    element: <WorkspaceUsers />,
  },
  {
    path: `${RoutesEnum.WORKSPACE_SETTINGS_BILLING}`,
    element: <WorkspaceBilling />,
  },
  {
    path: `${RoutesEnum.TASKS}`,
    element: <TasksPage />,
  },
  {
    path: `${RoutesEnum.AI}/:threadId?`,
    element: <AI />,
  },
  {
    path: '/playground',
    element: <Playground />,
  },
  {
    path: 'preview/project/:projectId',
    element: <ProjectPreview />,
  },
  {
    path: '/',
    element: <Navigate to={RoutesEnum.PROJECTS} replace />,
  },
])
